import React from 'react';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { uniqueId } from 'lodash';

const FILTER_REGEX = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

export const PhoneNumber = () => {
  const [phneNmbr, setPhneNmbr] = React.useState('');

  const handlePhoneNumber = (e) => {
    const phoneNmbr = e.target.value.replace(/\s/g, '').replace(/-/g, '');
    if (phoneNmbr.length < 10) {
      setPhneNmbr(phoneNmbr);
    }
  };

  return (
    <React.Fragment>
      <TextInput
        model="attestation.phoneNumber"
        id="phone-number"
        label="Phone number"
        value={phneNmbr}
        onChange={handlePhoneNumber}
        formatter={(value) => {
          return value
            .replace(/[!@#$%^&*)({}<>,.[\]+_`~=\\|';":/?A-Za-z]/g, '')
            .replace(FILTER_REGEX, '($1) $2-$3')
            .replace(/^ /g, '');
        }}
        maxLength={14}
        validators={{
          required: 'Phone number is required.',
          invalid: {
            value: (value) => {
              return value.replace(/\s/g, '').replace(/-/g, '').length < 10;
            },
            message: 'Please enter a valid phone number.',
          },
        }}
        data-testid="attestation-submitter-phone-number"
        name={`phone-input-${uniqueId()}`}
        autoComplete="none"
      />
    </React.Fragment>
  );
};

PhoneNumber.propTypes = {};

PhoneNumber.defaultProps = {};
